var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ pcStyle: _vm.isPc, mobileStyle: _vm.isMobile, rightLayout: _vm.alignRight },attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e(),_c('MyToast'),_c('MyLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }